// Returns a user-facing message from an axios error in a way that never throws.
// Saga catch blocks must use this rather than dereferencing error.response.data.msg directly —
// pre-response errors (offline, CORS, abort) leave `error.response` undefined and a naive read
// throws inside the catch, which means showAlert never fires and the spinner spins forever.
export function safeErrorMessage(error, fallback = 'Request failed') {
    return (
        error?.response?.data?.msg ||
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.message ||
        fallback
    );
}
